<style lang="scss" scoped>
.item-list {
  list-style: none;

  &:first-child {
    margin-top: .35rem;
  }

  .add-btn {
    padding: 0 !important;
    margin-left: -3px !important;
    text-transform: none;
    font-weight: normal;
  }
}
</style>

<template>
  <div>
    <label>{{ seniorFunderTitles[role.title] }} ({{ value ? value.length : 0 }})</label>
    <v-progress-linear
      v-if="loading"
      indeterminate
      color="black lighten-4"
      class="my-3"
    />
    <div v-else>
      <div v-if="error" class="pl-4 error--text">
        {{ error }}
      </div>
      <div v-else>
        <div v-if="value && value.length !== 0">
          <ul class="item-list">
            <li
              v-for="item in value"
              v-bind:key="item._id"
              @mouseover="() => $set(item, 'hover', true)"
              @mouseleave="() => $set(item, 'hover', false)"
            >
              <div class="d-flex">
                {{ item.display_name }}
                <v-btn
                  v-if="item.hover"
                  x-small
                  icon
                  :id="`team-remove-user-${item._id}-btn`"
                  @click="() => $emit('remove', role, item)"
                  v-if-has-permission:hide="removeTeamMemberPermission"
                >
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </div>
            </li>
          </ul>
        </div>
        <div v-else>
          <ul class="item-list">
            <li>-</li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint no-underscore-dangle: ["error", { "allow": ["_id"] }] */
import userMixin from '@/mixins/userMixin';
import roleMixin from '@/mixins/roleMixin';


export default {
  name: 'AdmingGroupTeamColumn',
  mixins: [userMixin, roleMixin],
  props: {
    seniorFunder: {
      type: Object,
      required: true,
    },
    role: {
      type: Object,
      required: true,
    },
    value: Array,
  },
  data: () => ({
    loading: false,
    error: null,
  }),
  computed: {
    removeTeamMemberPermission: vm => vm.$permissions.REMOVE_SENIOR_FUNDER_TEAM_MEMBER,
  },
  methods: {
    fetch() {
      this.loading = true;
      this.error = null;
      this.$requests.get(`/v1/senior-funders/${this.seniorFunder._id}/team?role_name=${this.role.title}`)
        .then(response => {
          this.$emit('input', this.resolveUsers(response.data.processors));
        })
        .catch(() => {
          this.error = 'Unable to resolve list';
        })
        .then(() => { this.loading = false; });
    },
  },
  mounted() {
    this.fetch();
  },
  watch: {
    seniorFunder(value) {
      if (value) {
        this.fetch();
      } else {
        this.$emit('input', []);
      }
    },
  },
};
</script>
